<div class="dialog-container">
  <!-- Header -->

  <!-- Content -->
  <div class="dialog-content">
    <!-- View Mode: Show destination details -->
    <div *ngIf="isViewMode" class="destination-view-stage">
      <div class="destination-detail-card">
        <div class="destination-header">
          <mat-icon class="destination-icon" [svgIcon]="getDestinationDisplayInfo().icon"></mat-icon>
          <div class="destination-title-section">
            <h2>{{ getDestinationDisplayInfo().format }}</h2>
            <p class="destination-category">{{ getDestinationDisplayInfo().category }}</p>
          </div>
        </div>
        
        <div class="destination-details">
          <div class="detail-row">
            <span class="detail-label">Status:</span>
            <span class="detail-value">
              <mat-icon [class]="effectiveData.destination?.isEnabled ? 'status-active' : 'status-inactive'" [svgIcon]="effectiveData.destination?.isEnabled ? 'check_circle' : 'cancel'">
                {{ effectiveData.destination?.isEnabled ? 'check_circle' : 'cancel' }}
              </mat-icon>
              {{ effectiveData.destination?.isEnabled ? 'Enabled' : 'Disabled' }}
            </span>
          </div>
          
          <div class="detail-row">
            <span class="detail-label">Created:</span>
            <span class="detail-value">{{ effectiveData.destination?.createdAt | date:'yyyy-MM-dd HH:mm' }}</span>
          </div>
          
          <div class="detail-row" *ngIf="effectiveData.destination?.updatedAt !== effectiveData.destination?.createdAt">
            <span class="detail-label">Last Updated:</span>
            <span class="detail-value">{{ effectiveData.destination?.updatedAt | date:'yyyy-MM-dd HH:mm' }}</span>
          </div>
          
          <div class="detail-row" *ngIf="effectiveData.destination?.settingsJson">
            <span class="detail-label">Configuration:</span>
            <span class="detail-value">Custom settings applied</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Create Mode: Destination Selection -->
    <div *ngIf="!isViewMode" class="destination-selection-stage">
      <!-- API Response Section -->
      <div class="section">
        <h3>{{ getCategoryTitle('api') }}</h3>
        <p class="category-description">{{ getCategorySubtitle('api') }}</p>
        <p class="category-usecase">{{ getCategoryUsecase('api') }}</p>
        <div class="destination-grid">
          <div *ngFor="let option of getOptionsByCategory('api')" 
               class="card-selectable destination-card"
               [class.selected]="isOptionSelected(option)"
               [class.disabled]="!isOptionAllowed(option)"
               [matTooltip]="getDisabledReason(option)"
               [matTooltipDisabled]="isOptionAllowed(option)"
               (click)="selectOption(option)">
            <mat-icon [svgIcon]="option.icon"></mat-icon>
            <div class="destination-info">
              <h4>{{ option.name }}</h4>
              <span class="destination-type">{{ option.description }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Output to File Section -->
      <div class="section">
        <h3>{{ getCategoryTitle('file') }}</h3>
        <p class="category-description">{{ getCategorySubtitle('file') }}</p>
        <p class="category-usecase">{{ getCategoryUsecase('file') }}</p>
        <div class="destination-grid">
          <div *ngFor="let option of getOptionsByCategory('file')" 
               class="card-selectable destination-card"
               [class.selected]="isOptionSelected(option)"
               [class.disabled]="!isOptionAllowed(option)"
               [matTooltip]="getDisabledReason(option)"
               [matTooltipDisabled]="isOptionAllowed(option)"
               (click)="selectOption(option)">
            <mat-icon [svgIcon]="option.icon"></mat-icon>
            <div class="destination-info">
              <h4>{{ option.name }}</h4>
              <span class="destination-type">{{ option.description }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Output to Database Section -->
      <!-- <div class="section">
        <h3>{{ getCategoryTitle('database') }}</h3>
        <p class="category-description">{{ getCategorySubtitle('database') }}</p>
        <p class="category-usecase">{{ getCategoryUsecase('database') }}</p>
        <div class="destination-grid">
          <div *ngFor="let option of getOptionsByCategory('database')" 
               class="card-selectable destination-card"
               [class.selected]="isOptionSelected(option)"
               [class.disabled]="!isOptionAllowed(option)"
               [matTooltip]="getDisabledReason(option)"
               [matTooltipDisabled]="isOptionAllowed(option)"
               (click)="selectOption(option)">
            <mat-icon [svgIcon]="option.icon"></mat-icon>
            <div class="destination-info">
              <h4>{{ option.name }}</h4>
              <span class="destination-type">{{ option.description }}</span>
            </div>
          </div>
        </div>
      </div> -->
      
      <!-- Data Summaries Section -->
      <!-- <div class="section">
        <h3>{{ getCategoryTitle('summary') }}</h3>
        <p class="category-description">{{ getCategorySubtitle('summary') }}</p>
        <p class="category-usecase">{{ getCategoryUsecase('summary') }}</p>
        <div class="destination-grid">
          <div *ngFor="let option of getOptionsByCategory('summary')" 
               class="card-selectable destination-card"
               [class.selected]="isOptionSelected(option)"
               [class.disabled]="!isOptionAllowed(option)"
               [matTooltip]="getDisabledReason(option)"
               [matTooltipDisabled]="isOptionAllowed(option)"
               (click)="selectOption(option)">
            <mat-icon [svgIcon]="option.icon"></mat-icon>
            <div class="destination-info">
              <h4>{{ option.name }}</h4>
              <span class="destination-type">{{ option.description }}</span>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>

  <!-- Actions -->
  <div class="dialog-actions">
    <!-- Error message -->
    <div *ngIf="error" class="error-message">
      <mat-icon>error</mat-icon>
      <span>{{ error }}</span>
    </div>
    
    <div class="action-buttons">
      <div class="right-buttons">
        <!-- View Mode: Delete and Close buttons -->
        <ng-container *ngIf="isViewMode">
          <button mat-button 
                  color="warn"
                  [disabled]="loading"
                  (click)="onDelete()"
                  class="delete-button">
              <mat-icon svgIcon="delete"></mat-icon>
              Delete Output
            </button>
          
          <button mat-raised-button 
                  color="primary"
                  (click)="onCancel()"
                  class="close-button">
            Close
          </button>
        </ng-container>
        
        <!-- Create Mode: Cancel and Set Destination buttons -->
        <ng-container *ngIf="!isViewMode">
          <button mat-button (click)="onCancel()" class="cancel-button">
            Cancel
          </button>
          
          <!-- Confirm button - goes straight to creating the destination -->
          <button mat-raised-button 
                  color="primary" 
                  [disabled]="!canProceed() || loading"
                  (click)="onConfirm()"
                  class="confirm-button">
            <mat-icon *ngIf="loading">hourglass_empty</mat-icon>
            {{ getConfirmButtonText() }}
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
